/**
 * Configuração da API
 * Em desenvolvimento: usa proxy do Vite (mesmo host)
 * Em produção com NPM/Nginx: usa mesma origem (proxy reverso)
 */

// Detecta se está em produção baseado na URL atual
const isProduction = typeof window !== 'undefined' && 
  !window.location.hostname.includes('localhost') &&
  !window.location.hostname.includes('127.0.0.1');

// Em produção com Nginx Proxy Manager:
// - Frontend e API estão no mesmo domínio
// - NPM roteia /claro/api para o backend na porta 3161
// - Não precisa especificar porta, usa URL relativa
const getApiBaseUrl = () => {
  // Sempre usa URL relativa - o proxy reverso cuida do roteamento
  return '';
};

export const API_BASE_URL = getApiBaseUrl();

/**
 * Retorna a URL base para chamadas à API
 */
export function getApiUrl(path: string): string {
  // Remove barra inicial se existir para evitar //
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${cleanPath}`;
}

/**
 * Fetch wrapper com URL base da API
 */
export async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const url = getApiUrl(path);
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });
  
  if (!response.ok) {
    throw new Error(`API Error: ${response.status} ${response.statusText}`);
  }
  
  return response.json();
}
